import esLocale from '@ods/ods/lib/locale/lang/es'

export default {
  ...esLocale,
  label: 'Español',
  labelMobile: 'ES',
  serverError: 'Ha ocurrido un error inesperado en el servidor. Inténtalo de nuevo.',
  noResults: 'No se han encontrado resultados',
  close: 'Cerrar',
  login: {
    title: 'Iniciar sesión',
    user: 'Nombre de usuario',
    password: 'Contraseña',
    submitButton: 'Enviar',
    rules: {
      user: 'Introduzca el usuario',
      password: 'Introduzca la contaseña'
    },
    logging: 'Iniciando sesión...',
    loginErrorTitle: 'Error de validación.',
    loginError: 'La combinación usuario/contraseña no es valida.',
    forgotPassword: '¿Has olvidado tu contraseña?',
    keepMeLogged: 'Mantener sesión iniciada',
    login: 'Entrar',
    // footerLinks: ['faq', 'términos', 'condiciones'],
    footerLinks: [],
    social: {
      title: 'Haz login con'
    }
  },
  password: {
    title: 'Restablecer contraseña',
    message: 'Introduce una cuenta de correo electrónico vinculada al producto para continuar',
    email: 'Correo electrónico',
    submitButton: 'Enviar',
    goBack: 'Volver',
    error: 'Email no encontrado.',
    sending: 'Enviando...',
    rules: {
      email: 'Email no encontrado'
    },
    emailSubmitted: 'Hemos enviado un correo electrónico con instrucciones para poder restablecer su contraseña a:',
    done: 'Finalizar',
    emailError: 'No existe ninguna cuenta vinculada a este correo electrónico: '
  },
  notifications: {
    popoverTitle: 'Notificaciones'
  },
  breadcrumb: {
    home: 'Cadenas - Comercios',
    dashboard: 'Usuarios Portal',
    comercio: 'Comercio',
    comercios: 'Comercios',
    movimiento: 'Movimiento',
    tasks: 'Tareas',
    users: 'Usuarios',
    randomUser: 'Usuario random ',
    randomString: 'Random string param: ',
    editProfile: 'Editar mi perfil',
    myUser: 'Mi usuario',
    editUser: 'Editar usuario',
    info: 'Comercio',
    recibos: 'Recibos',
    facturas: 'Facturas',
    loyalty: 'Fidelización',
    programs: 'Programas',
    accounts: 'Cuentas',
    coupons: 'Cupones',
    marketing: 'Marketing',
    Analytics: 'Analytics',
    clients: 'Clientes',
    TemplatesDetails: 'Plantillas',
    TemplatesDetails2: 'Detalles de Plantilla',
    CouponsAsing: 'Asignar cupón'
  },
  dashboard: {
    chains: 'Cadenas',
    businesses: 'Comercios',
    searchHere: 'Busque aquí',
    noResultsCommerces: 'No se han encontrado comercios para esa cadena',
    loadingCommerces: 'Cargando comercios...'
  },
  commerceInfo: {
    codeInCommerce: 'Código interno del comercio',
    chain: 'Cadena',
    address: 'Dirección',
    status: 'Estado',
    product: 'Producto',
    rates: 'Tarifas',
    rateType: 'Tipo de tarifario',
    ratesGeneral: 'Tarifa General',
    ratesCards: 'Tarifa por Tipos de tarjeta',
    ratesFinancing: 'Tarifa por Tipos de financiación',
    ratesRappel: 'Tarifa por Rappel',
    listVendors: 'Listado de Vendedores',
    SellerRegistration: 'Alta Vendedor',
    listRequests: 'Listado de Solicitudes',
    listFinancing: 'Tipos de Financiación',
    listReceipts: 'Listado de Recibos emitidos',
    users: 'Usuarios',
    staff: 'Empleados',
    terminalsInquiries: 'Terminales',
    terminals: 'Terminales QR',
    commerceTPV: 'TPV Comercio',
    movements: 'Movimientos',
    dataSeller: 'Datos vendedor',
    ContactInformation: 'Datos de contacto',
    bankData: 'Datos bancarios',
    modifyData: 'Modificar datos',
    editData: 'Editar datos',
    accept: 'Aceptar',
    commissions: 'Comisiones',
    rappel: 'Rappel',
    vendors: 'Vendedores',
    requests: 'Solicitudes',
    financing: 'Financiaciones',
    invoice: 'Facturas',
    receipts: 'Recibos'
  },
  terminalDetail: {
    cod: 'Código de terminal',
    class: 'Clase de terminal',
    qr: 'Admite código QR',
    type: 'Tipo',
    descriptionType: 'Descripción tipo de terminal',
    displaced: 'Terminal desplazado',
    model: 'Modelo',
    description: 'Descripción',
    codCICS: 'Código CICS de terminal',
    highDate: 'Fecha de alta',
    lowDate: 'Fecha de baja',
    lowMotive: 'Motivo de baja',
    situation: 'Situación',
    instalationDate: 'Fecha instalación',
    lastOperationDate: 'Fecha última operación',
    owner: 'Propietario',
    tpvManagement: 'Gestión del TPV',
    tpvSesion: 'Sesión TPV',
    observations: 'Datos técnicos TPV'
  },
  tabTariff: {
    loadingSections: 'Cargando tramos...',
    notFoundSections: 'No se han encontrado tramos asociados a esta tarifa'
  },
  loyalty: {
    programsDescription: 'Aquí puedes ver tus programas de fidelidad y el detalle de su configuración.',
    accountsDescription: 'Aquí puedes ver las cuentas asociadas a tus programas de fidelidad, su estado, movimientos y el detalle de los puntos que se han acumulado, redimido y cancelado.',
    couponsDescription: 'Aquí puedes visualizar los distintos tipos de cupones asociados a tu programa de fidelidad, los cupones que se han utilizado, qué cuentas han canjeado y asignar cupones a las cuentas de fidelidad que quieras.',
    marketingDescription: 'Aquí puedes generar acciones automáticas para contactar con clientes. Podrás segmentar los clientes a quienes quieras enviar comunicados o asignar cupones de manera automática.',
    AnalyticsDescription: 'Aquí podrás visualizar un cuadro de mandos para ir viendo cómo está evolucionando tu programa de fidelidad.',
    generalData: 'Datos Generales',
    codprog: 'Código de programa',
    description: 'Descripción',
    validity: 'Vigencia',
    equivalenceRatio: 'Ratio de equivalencia',
    typeAccount: 'Tipo de cuenta',
    since: 'Desde',
    until: 'hasta',
    realtimepointinf: 'Información de puntos en tiempo real',
    operationaldata: 'Datos Operativos',
    Bankstatement: 'Extractos',
    mailstatement: 'Envío de extracto',
    nextreleasedate: 'Fecha próximo envío',
    maximumpoints: 'Puntos máximos',
    points: 'Puntos',
    expirationcriteria: 'Criterio de caducidad',
    periodicity: 'Periodicidad revisión puntos caducados',
    automaticaward: 'Premio Automático',
    catalog: 'Catálogo',
    cancelpointafteraward: 'Anulación de puntos tras premio',
    redemptionperiodicity: 'Periodicidad del canje',
    lastredemtion: 'Último canje',
    nextredemtion: 'Próximo canje',
    immediateReward: 'Indicador de premio inmediato',
    periodValidity: 'Periodo de vigencia',
    pointsTransferIndicator: 'Indicador de transferencia de puntos',
    commerces: 'Comercios',
    channel: 'Canales',
    chanelpercentage: 'Porcentaje canal',
    emitterpercentage: 'Porcentaje emisor',
    code: 'Código',
    search: 'Buscar',
    holding: 'Holding',
    commercialchain: 'Cadena Comercial',
    storecode: 'Código Comercio',
    commerce: 'Comercio',
    allCounts: 'Todas las cuentas',
    activeCounts: 'Cuentas activas sin bloqueo',
    blockedAccount: 'Cuentas activas con bloqueo de redención y/o acumulación',
    closedAccount: 'Cuentas cerradas',
    loyaltyAccount: 'Cuenta fidelidad',
    accounts: 'Cuentas',
    account: 'Cuenta',
    client: 'Cliente',
    Idtype: 'Tipo de identificador',
    IdNumber: 'Identificador Cliente',
    State: 'Estado',
    currentstate: 'Estado actual',
    accumulationBlockage: 'BLQ. ACUM',
    redeemableLock: 'BLQ. CANJE',
    totalPoints: 'Puntos totales',
    pointsDetails: 'Detalle puntos',
    transactions: 'Movimientos',
    availablePoints: 'Puntos Disponibles',
    opened: 'Activa',
    blocked: 'Bloqueada',
    closed: 'Cerrada',
    totalPointsAccumulated: 'Total puntos acumulados',
    totalDefCancelPoints: 'Total puntos anulados definitivos',
    totalPointsExceeded: 'Total puntos excedidos',
    totalPointsExpired: 'Total puntos caducados',
    totalPointsRetainedManually: 'Total puntos retenidos manuales',
    totalPointsRetainStandby: 'Total puntos retenidos en espera',
    totalPointsRetainBlockage: 'Total puntos retenidos por bloqueo',
    date: 'Fecha',
    concept: 'Concepto',
    accumulablePointsMovements: 'PTS acumulables',
    avaiablePointsMovements: 'PTS disponibles',
    accumulablePoints: 'Puntos acumulables',
    avaiablePoints: 'Puntos disponibles',
    currentStatus: 'Situación',
    Cumulative: 'Acumulable',
    HoldInStandby: 'Retenido en espera',
    ManualHold: 'Retenido manual',
    HeldByBlocking: 'Retenido por bloqueo',
    Released: 'Liberado',
    DefinitiveAnnulled: 'Anulado definitivo',
    Expired: 'Caducado',
    Informative: 'Informativo',
    FullyRedeemed: 'Canjeado totalmente',
    TransferredToAnotherAccount: 'Traspasado a otra cuenta',
    CancelledAfterAutomaticAward: 'Anulado tras premio automático',
    Exceeded: 'Excedido',
    Penalized: 'Penalizado',
    noData: 'Sin Datos',
    newAccount: 'Nueva cuenta',
    noExpirationDate: 'Sin caducidad',
    directedOlder: 'Dirigido por más antiguo',
    directedNewest: 'Dirigido por más nuevo',
    customerCategory: 'Por categoría de cliente',
    seePointsDetails: 'Ver detalle de puntos',
    yes: 'SI',
    no: 'NO',
    personalData: 'Datos personales',
    documentType: 'Tipo de documento',
    name: 'Nombre',
    firstName: 'Primer apellido',
    lastName: 'Segundo apellido',
    gender: 'Género',
    male: 'Masculino',
    female: 'Femenino',
    adress: 'Dirección',
    region: 'Región',
    city: 'Ciudad',
    postalCode: 'Código postal',
    email: 'Email',
    dni: 'Identificador Cliente',
    phone: 'Teléfono',
    checkDNI: 'Comprobar cliente',
    cancel: 'Cancelar',
    requiredFields: '(*) Campos obligatorios',
    advancedSearch: 'Búsqueda avanzada',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin',
    automaticRedemption: 'Redención Automática',
    manualRedemption: 'Redención Manual',
    apply: 'Aplicar',
    save: 'Guardar',
    totalPointsAvaible: 'Total puntos disponibles',
    totalAccumulatedPoints: 'Total puntos acumulados',
    totalDefinitiveAnnulledPoints: 'Total puntos anulados definitivos',
    totalManualRetainedPoints: 'Total puntos retenidos manuales',
    totalPointsHeldSuspense: 'Total puntos retenidos en espera',
    totalPointsWithheldBlockage: 'Total puntos retenidos por bloqueo',
    totalPointsReleased: 'Total puntos liberados',
    totalPointsPenalized: 'Total puntos penalizados',
    totalPointsRedeemed: 'Total puntos canjeados',
    userExist: 'Cliente existente',
    userNotExist: 'El cliente no existe',
    continue: 'Continuar',
    createAccount: 'Cuenta creada correctamente',
    create: 'Crear',
    logout: 'Cerrar sesión',
    requireField: 'Campo Obligatorio',
    invalidFormat: 'El formato no es válido',
    birthDate: 'Fecha de nacimiento',
    maritalStatus: 'Estado civil',
    maritalStatusArr: ['Selecciona el estado civil', 'Soltero/a', 'Casado/a', 'Viudo/a', 'Divorciado/a', 'Separado/a', 'Convivencia'],
    notAllowedCharacters: 'Existen caracteres no permitidos',
    typeIdentif: 'Tipo identif.',
    templates: 'Plantillas',
    assignment: 'Asignaciones',
    liquidation: 'Liquidación',
    minimumAmount: 'Importe mínimo',
    maxCoupon: 'Máx. Cupones',
    couponsAssigned: 'Cupones Asignados',
    TemplatesDetails2: 'Detalle de Plantilla',
    mainData: 'Datos principales',
    configuration: 'Configuración',
    couponCoversion: 'Conversión del Cupón',
    program: 'Programa',
    templateTitle: 'Título de la plantilla',
    BasedOnBonus: 'Basado en la bonificación',
    subtitle: 'Subtítulo',
    couponCoins: 'Monedas del Cupón',
    pointToRedeemed: 'Puntos a canjear',
    amountValue: 'Valor del importe',
    roundToPoints: 'Redondear las unidades superiores a puntos',
    valueType: 'Tipo de Descuento',
    discountvalue: 'Valor del descuento',
    chanelUse: 'Canal de uso',
    minImp: 'Importe min. de compra',
    maxBon: 'Importe Máx. de bonificación',
    maxCoupons: 'Número máximo de cupones',
    tranferCoupon: 'Permitir traspaso de cupones',
    defaultState: 'Estado por defecto del cupón',
    oneCommerce: 'Un único comercio',
    commerceamount: 'Cantidad aportada por el comercio',
    preview: 'Previsualización',
    in: 'En',
    valid: 'Válido',
    coupons: 'Cupones',
    totalCoupon: 'Total de cupones',
    couponsUsed: 'Cupones utilizados',
    couponsUnused: 'Cupones no utilizados',
    asignedcoupons: 'Cupones asignados',
    template: 'Plantilla',
    identifier: 'Identificador',
    AsignedCouponDate: 'Fecha Asignación Cupón',
    DateUseCoupon: 'Fecha Uso Cupón',
    CouponSituation: 'Situación Cupón',
    used: 'Utilizado',
    notUsed: 'No utilizado',
    sincede: 'desde el',
    untilde: 'hasta el',
    assignCoupon: 'Asignar Cupón',
    clean: 'Limpiar',
    singlechannel: 'Canal',
    select: 'Seleccionar',
    Permanent: 'Fijo',
    Percentage: 'Porcentual',
    CouponsAsing: 'Asignar cupón a {alaplantilla}',
    selectTemplate: 'Seleccionar plantilla ({pag}/2)',
    selectOneTemplate: 'Selecciona la plantilla que quieres asignar',
    prev: 'Anterior',
    next: 'Siguiente',
    viewCoupon: 'Ver cupón',
    viewSelectedCoupon: 'Ver cupón seleccionado',
    selectAccountsCoupon: 'Seleccionar cuentas para el cupón {nombrecupon} (2/2)',
    selectAccountsCouponDesc: 'Selecciona como máximo 20 cuentas para asociarlas al mismo tiempo. ',
    analytics: {
      working: '(en construcción)',
      lastWeek: 'Últimos 7 días',
      lastWeekWarning: 'El {startDate} se ha cambiado a 7 días antes del {endDate}. Sólo se permiten intervalos de 7 días.',
      allClients: 'Todos los clientes',
      allAccounts: 'Todas las cuentas creadas, bloqueadas y/o cerradas en el período',
      activeAccounts: 'Cuentas creadas en el período',
      blockedAccounts: 'Cuentas bloqueadas en el período',
      closedAccounts: 'Cuentas cerradas en el período',
      infoAccounts: 'En el período seleccionado una misma cuenta puede haber pasado por varios estados.',
      active: 'Creadas',
      blocked: 'Bloqueadas',
      closed: 'Cerradas',
      affectedAccounts: '{total} cambio(s) de estado en {totalreal} cuenta(s) en el período',
      affectedTotalAccounts: 'sobre {total} cuentas',
      regCllients: 'Clientes dados de alta en el período',
      men: 'Hombres',
      noinfo: 'No informados',
      women: 'Mujeres',
      xAxisName: '7 días hasta el {endDate}',
      clientDetails: 'Detalles del cliente'
    }
  }
}
